import { getMarket, getMarketFromCityState } from '@atc/bonnet-reference';
import { getCityZipCode } from '../utilities';
import { LOCATION_PRIORITY_ALL } from '@atc/bonnet-reference-cache/constants';

const getLocationFromSlug = async (slug = []) => {
    let location = null;
    let originalSegment = null;

    // Find the location segment (skip non-location segments like 'car-dealers', 'dealers')
    originalSegment = slug.find((segment) => {
        const parts = segment.split('-');
        // Location segment should have at least 2 parts and end with a 2-letter state code
        return parts.length >= 2 && /^[a-z]{2}$/.test(parts[parts.length - 1]);
    });

    if (originalSegment) {
        const splitLocations = originalSegment.split('-');
        const state = splitLocations.splice(splitLocations.length - 1)[0];
        const city = splitLocations.join('-');
        const { success, payload } = await getMarketFromCityState({ city, state });
        const cityCenterZip = await getCityZipCode({ city, state }, '', LOCATION_PRIORITY_ALL);

        if (success && payload) {
            location = {
                city: payload.city,
                state: payload.state,
                zip: cityCenterZip || payload.zip,
            };
        } else if (cityCenterZip) {
            const { success: marketSuccess, payload: marketPayload } = await getMarket(cityCenterZip);
            if (marketSuccess && marketPayload) {
                location = {
                    city: marketPayload.city,
                    state: marketPayload.state,
                    zip: cityCenterZip,
                };
            }
        }
    }

    return { location, originalLocation: originalSegment };
};

export default function withCtxCommonQuery() {
    return async (ctx) => {
        if (!ctx.query.zip) {
            const { location, originalLocation } = await getLocationFromSlug(ctx.query.slug);

            if (location) {
                ctx.data.originalLocation = originalLocation;

                ctx.query = {
                    ...ctx.query,
                    city: location.city,
                    state: location.state,
                    zip: location.zip,
                };
                ctx.data.hasLocationPath = true;
            } else if (originalLocation) {
                ctx.data.originalLocation = originalLocation;
            }
        }
    };
}
